import { tv } from './chunk-7NOFBOMW.js';
import { forwardRef } from 'react';
import { jsx } from 'react/jsx-runtime';

var cardStyles = tv({
  base: "bg-card text-card-foreground rounded-xl border shadow-sm"
});
var Card = forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx("div", { ref, className: cardStyles({ className }), ...props }));
Card.displayName = "Card";
var cardHeaderStyles = tv({
  base: "flex flex-col space-y-1 p-6"
});
var CardHeader = forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx("div", { ref, className: cardHeaderStyles({ className }), ...props }));
CardHeader.displayName = "CardHeader";
var cardTitleStyles = tv({
  base: "font-semibold leading-none text-2xl"
});
var CardTitle = forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx("h3", { ref, className: cardTitleStyles({ className }), ...props }));
CardTitle.displayName = "CardTitle";
var cardDescriptionStyles = tv({
  base: "text-muted-foreground text-sm"
});
var CardDescription = forwardRef(
  ({ className, ...props }, ref) => /* @__PURE__ */ jsx("p", { ref, className: cardDescriptionStyles({ className }), ...props })
);
CardDescription.displayName = "CardDescription";
var cardContentStyles = tv({
  base: "p-6 pt-0"
});
var CardContent = forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx("div", { ref, className: cardContentStyles({ className }), ...props }));
CardContent.displayName = "CardContent";
var cardFooterStyles = tv({
  base: "flex items-center p-6 pt-0"
});
var CardFooter = forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx("div", { ref, className: cardFooterStyles({ className }), ...props }));
CardFooter.displayName = "CardFooter";

export { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle, cardContentStyles, cardDescriptionStyles, cardHeaderStyles, cardStyles, cardTitleStyles };
//# sourceMappingURL=chunk-2YLF67YR.js.map
//# sourceMappingURL=chunk-2YLF67YR.js.map